import {createSlice} from "@reduxjs/toolkit";
import {quickClone} from "../../../_helpers/commonFunctions";

const initialNewTransfer = {
    qrUrl: "",
    vehicleNumber: "",
    transportType: "1",
    timeStamp: "",
    carrierVatNumber: "",
    pNumber: "",
    location: {},
    longitude: "",
    latitude: "",
}

const initialState = {
    invoicesTable: [],
    selectedRows: [], // Array of qrUrls
    openRows: [], // Array of qrUrls

    viewTransfer: quickClone(initialNewTransfer),

    reportSelectedRows: [], // Array of objects of selected items
    reportOpenRows: [], // Array of qrUrls
    transferReportRequestData: {
        page: 1,
        date_from: "",
        date_to: "",
        status: [],
        general: "",
        invoiceRole: "",
        b2Option: "",
    },
    transfersReportResponseData: {
        data: [],
        totalItems: 0,
        totalPages: 0,
    },

    generatedQrsRequestData: {
        page: 1,
        dateFrom: "",
        dateTo: "",
    },
    generatedQrsResponseData: {
        data: [],
        totalItems: 0,
        totalPages: 0,
    },

    autoTransfer: null,
}

export const TransfersSlice = createSlice({
    name: "Transfers",
    initialState,
    reducers: {
        // New Transfer
        setInvoicesTable: (state, {payload}) => {
            state.invoicesTable = payload;
        },
        setTransferSelectedRows: (state, {payload}) => {
            state.selectedRows = payload;
        },
        setTransferOpenRows: (state, {payload}) => {
            state.openRows = payload;
        },
        setAutoTransfer: (state, {payload}) => {
            state.autoTransfer = payload;
        },

        // View Transfer
        setViewTransfer: (state, {payload}) => {
            state.viewTransfer = payload;
        },

        // Transfers Report
        setTransfersReportRequestData: (state, {payload}) => {
            state.transferReportRequestData = payload;
        },
        setTransfersReportResponseData: (state, {payload}) => {
            state.transfersReportResponseData = payload;
        },
        setTransfersReportSelectedRows: (state, {payload}) => {
            state.reportSelectedRows = payload;
        },
        setTransfersReportOpenRows: (state, {payload}) => {
            state.reportOpenRows = payload;
        },

        // Generated Group QRs
        setGroupQRRequestData: (state, {payload}) => {
            state.generatedQrsRequestData = payload;
        },
        setGroupQRResponseData: (state, {payload}) => {
            state.generatedQrsResponseData = payload;
        }
    },
});

export const {
    setInvoicesTable,
    setTransferSelectedRows,
    setTransferOpenRows,
    setViewTransfer,
    setAutoTransfer,

    // Transfers Report
    setTransfersReportRequestData,
    setTransfersReportResponseData,
    setTransfersReportSelectedRows,
    setTransfersReportOpenRows,

    // Group QR Report
    setGroupQRRequestData,
    setGroupQRResponseData,
} = TransfersSlice.actions;